"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _Box = _interopRequireDefault(require("../Box"));

var _Card = _interopRequireDefault(require("../Card"));

var _IconButton = _interopRequireDefault(require("../IconButton"));

var _Typography = require("../Typography");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _Progress = _interopRequireDefault(require("./Progress"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _StyledCard = (0, _styledComponents["default"])(_Card["default"]).withConfig({
  displayName: "ToastCard___StyledCard",
  componentId: "sgxqy9-0"
})(["position:relative;", ""], function (p) {
  return p._css;
});

var _StyledBox = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "ToastCard___StyledBox",
  componentId: "sgxqy9-1"
})(["position:absolute;top:4px;right:4px"]);

var _StyledProgress = (0, _styledComponents["default"])(_Progress["default"]).withConfig({
  displayName: "ToastCard___StyledProgress",
  componentId: "sgxqy9-2"
})(["position:absolute;left:0;bottom:0;"]);

var ToastCard = (0, _react.forwardRef)(function (_ref, ref) {
  var variant = _ref.variant,
      title = _ref.title,
      Content = _ref.content,
      onClose = _ref.onClose,
      timeout = _ref.timeout,
      cssFromProps = _ref.css,
      props = _objectWithoutProperties(_ref, ["variant", "title", "content", "onClose", "timeout", "css"]);

  var styles = theme[variant];
  return _react["default"].createElement(_StyledCard, _extends({
    width: 320,
    px: 4,
    py: 4,
    bg: "white",
    borderRadius: 4,
    boxShadow: 3,
    ref: ref
  }, styles.container, props, {
    _css: cssFromProps || ''
  }), title && _react["default"].createElement(_Typography.Heading, _extends({
    width: 248,
    mb: 1,
    size: 6,
    fontWeight: 700
  }, styles.text), title), isComponent(Content) ? _react["default"].createElement(Content, null) : _react["default"].createElement(_Typography.Text, _extends({
    fontSize: 1
  }, styles.text), Content), _react["default"].createElement(_StyledBox, null, _react["default"].createElement(_IconButton["default"], _extends({}, styles.icon, {
    fontSize: 0,
    lineHeight: "100%",
    onClick: onClose
  }), _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faTimes
  }))), _react["default"].createElement(_StyledProgress, _extends({
    timeout: timeout,
    onClose: onClose
  }, styles.progress)));
});
ToastCard.propTypes = {
  variant: _propTypes.string,
  title: _propTypes.string,
  content: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node, _propTypes.element, _propTypes.elementType]),
  onClose: _propTypes.func.isRequired,
  timeout: _propTypes.number,
  css: _propTypes.string
};
var _default = ToastCard;
exports["default"] = _default;
var theme = {
  neutral: {
    container: {
      bg: 'white'
    },
    text: {
      color: 'neutral.900'
    },
    icon: {},
    progress: {
      bg: 'neutral.700'
    }
  },
  info: {
    container: {
      bg: 'primary.100'
    },
    text: {
      color: 'primary.900'
    },
    icon: {
      variant: 'primary'
    },
    progress: {
      bg: 'primary.700'
    }
  },
  error: {
    container: {
      bg: 'red.100'
    },
    text: {
      color: 'red.900'
    },
    icon: {
      variant: 'danger'
    },
    progress: {
      bg: 'red.700'
    }
  }
};

var isClassComponent = function isClassComponent(component) {
  return typeof component === 'function' && !!component.prototype.isReactComponent ? true : false;
};

var isFunctionComponent = function isFunctionComponent(component) {
  return typeof component === 'function' && String(component).includes('return React.createElement') ? true : false;
};

var isComponent = function isComponent(c) {
  return isClassComponent(c) || isFunctionComponent(c);
};